"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LatencyTest = void 0;
class LatencyTest {
    constructor() {
        this.endTime = null;
        this.startTime = performance.now();
        this.signal = new Promise((resolve) => {
            this.resolve = resolve;
        });
    }
    receivedResponse() {
        this.endTime = performance.now();
        this.resolve();
    }
    async result() {
        await this.signal;
        return this.endTime - this.startTime;
    }
}
exports.LatencyTest = LatencyTest;
